// ──────────────────────────────────────────────────────────────
// 나이·개월수 계산 — 단일 진실 공급원(single source of truth)
//
// 앱 전체(자녀 나이·혜택 연령 매칭·도서관 대상 필터 등)가 쓰는 기본 유틸.
// 화면(App.js)과 회귀 테스트(scripts/test-dateUtils.js)가 같은 함수를 공유.
//
// 테스트 가능하도록 기준 시각(now)을 선택 인자로 받음(기본값=현재).
//   - 화면 호출부는 age(b) / mons(b) 그대로 사용(now 생략 → 현재 시각).
//   - 테스트는 고정된 now를 넘겨 결과를 결정적으로 검증.
// (2026-06-18 모듈화 3단계)
// ──────────────────────────────────────────────────────────────

// 만 나이 — 생일 안 지났으면 -1살 보정. 값 없음/이상값은 -1.
function age(b, now) {
  if (!b) return -1;
  const t = now || new Date();
  const br = new Date(b);
  if (isNaN(br)) return -1;
  let a = t.getFullYear() - br.getFullYear();
  if (t.getMonth() - br.getMonth() < 0 ||
     (t.getMonth() === br.getMonth() && t.getDate() < br.getDate())) a--;
  return a;
}

// 개월수(만) — 값 없음/이상값은 999(매칭에서 제외되도록 큰 값).
// age()와 동일하게 "일" 보정: 이달 일수가 생일 일수 미만이면 아직 그 개월수 미도달 → -1.
// (2026-07-03 전수QA: 보정 없으면 월말 출생아의 첫만남이용권(mons<24) 등이 최대 29일 일찍 사라짐.
//  년·월만 입력된 프로필은 Date 파싱 시 일=1이라 보정 무영향.)
function mons(b, now) {
  if (!b) return 999;
  const br = new Date(b);
  if (isNaN(br)) return 999;
  const t = now || new Date();
  let m = (t.getFullYear() - br.getFullYear()) * 12 + (t.getMonth() - br.getMonth());
  if (t.getDate() < br.getDate()) m--;
  // 미래 생년월일(아직 안 태어난 자녀·오입력)은 개월수 음수 → 999로 제외.
  // (2026-07-10 3AI감사 MED: Math.max(0,m)로 0개월 clamp 시 미래날짜가 첫만남이용권<24·출산축하금<12 등 신생아 혜택에 오매칭)
  return m < 0 ? 999 : m;
}

module.exports = { age, mons };
